import { useEffect, useState } from "react";
import { Grid, KpiCard, Box, Divider, Typography } from "../../../components";
import { responseErros } from "../../../utils";
import {
  GruposTributarioService,
  notification,
  ProdutosService,
} from "../../../services";
import PainelAnaliseFiscalProdutosGrupoTributario from "./painel-analise-fiscal-produtos-grupo-tributario/painel-analise-fiscal-produtos-grupo-tributario";
import PainelAnaliseFiscalProdutosNcm from "./painel-analise-fiscal-produtos-ncm/painel-analise-fiscal-produtos-ncm";

const gruposTributarioService = new GruposTributarioService();
const produtosService = new ProdutosService();

export default function PainelAnaliseFiscalProdutos({
  loading = false,
  analiseFiscalAi = {
    produtosAnalisados: 0,
    ncmsComInconsistencia: 0,
    gruposTributacaoIncorretos: 0,
    ncmsInconsistentes: [],
    gruposIncorretos: [],
  },
}) {
  const [gruposTributacao, setGruposTributacao] = useState([]);
  const cards = [
    {
      title: "Produtos Analizados",
      value: analiseFiscalAi.produtosAnalisados,
      icon: "ph-fill ph-cube",
      color: "#1976d2",
    },
    {
      title: "NCMs com inconsistência",
      value: analiseFiscalAi.ncmsComInconsistencia,
      icon: "ph-bold ph-receipt-x",
      color: "#d32f2f",
    },
    {
      title: "Grupos de Tributação incorretos",
      value: analiseFiscalAi.gruposTributacaoIncorretos,
      icon: "ph-bold ph-warning",
      color: "#f57c00",
    },
  ];

  useEffect(() => {
    buscarGruposTributario();
  }, []);

  const buscarGruposTributario = () => {
    const filter = {
      ativado: true,
      nonPaginated: true,
    };
    gruposTributarioService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setGruposTributacao(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  async function revisarProdutoAnaliseFiscal(produtos, setOpenModal) {
    const result = await produtosService.atualizarListaPainelAnaliseFiscal(
      produtos,
    );
    if (!result.isAxiosError) {
      notification.sucessoGenericos("Produtos revisados com sucesso!");
      setOpenModal(false);
    } else {
      responseErros(result);
    }
  }

  return (
    <>
      <Grid container spacing={2} sx={{ mb: 1 }}>
        <Grid item xs={12}>
          <Box display="flex" alignItems="center" gap={1.5} className="mb-3">
            <Box
              sx={{
                width: 46,
                height: 46,
                borderRadius: 2,
                backgroundColor: "#1976d218",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <i
                className="ph-bold ph-tag"
                style={{ color: "#1976d2", fontSize: 22 }}
              />
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography
                variant="h5"
                sx={{ fontWeight: 700, lineHeight: 1.1, color: "#1e293b" }}
              >
                Classificação dos produtos
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  display: "block",
                  color: "text.disabled",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                Grupos, NCM/CFOP e tratamento tributário aplicado
              </Typography>
            </Box>
          </Box>
          <Divider sx={{ mb: 2 }} />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mb: 3 }}>
        {cards.map((card) => (
          <Grid key={card.title} item xs={6} md={4}>
            <KpiCard
              title={card.title}
              value={card.value}
              icon={card.icon}
              color={card.color}
              loading={loading}
            />
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={2} alignItems="stretch">
        <PainelAnaliseFiscalProdutosNcm
          loading={loading}
          analiseFiscalAi={analiseFiscalAi}
          revisarProdutoAnaliseFiscal={revisarProdutoAnaliseFiscal}
        />
        <PainelAnaliseFiscalProdutosGrupoTributario
          loading={loading}
          analiseFiscalAi={analiseFiscalAi}
          gruposTributacao={gruposTributacao}
          revisarProdutoAnaliseFiscal={revisarProdutoAnaliseFiscal}
        />
      </Grid>
    </>
  );
}
